import { useQuery } from 'react-query';

import { makeFetchUnitPaymentMethodsUseCase } from 'modules/customer/domain/useCases';
import { customerQueries } from 'modules/customer/presentation/constants';
import { useRequestErrorHandler } from 'shared/presentation/hooks';

type TParams = {
  unitId: number;
};

export default function useUnitPaymentMethods(params: TParams) {
  const { handleError } = useRequestErrorHandler('customer');

  const query = useQuery(
    customerQueries.unitPaymentMethods(params.unitId),
    () =>
      makeFetchUnitPaymentMethodsUseCase().execute({ unitId: params.unitId }),
    {
      onError: error => handleError(error),
    },
  );

  return {
    loading: query.isLoading,
    methods: query.data || [],
  };
}
